import React, { useState, useCallback } from "react";
import { Button, Modal, Icon, Form } from "semantic-ui-react";
import { uploadRmBuddiesExcel } from "../../../redux/rm-buddies/actions";

import { useDispatch, useSelector } from "react-redux";

function MultiCreateRmBuddies() {
  const [file, setFile] = useState();
  const fileUploaded = useSelector(
    ({ rmBuddies }) => rmBuddies.rmBuddiesUploaded
  );

  const onChangeHandler = useCallback(
    event => {
      setFile(event.target.files[0]);
    },
    [setFile]
  );

  const dispatch = useDispatch();
  const submitButtonHandler = useCallback(async () => {
    const data = new FormData();
    data.append("file", file);
    dispatch(uploadRmBuddiesExcel(data));
  }, [dispatch, file]);
  return (
    <div class="MultiCreateRmBuddies">
      <Modal open={true} size="tiny">
        {!fileUploaded && (
          <Modal.Content className="center-text">
            <Icon name="file" />
            <br />
            <br />
            <p>
              Upload excel file of RM Buddies details. This will only insert new
              phone numbers and RMBddies. To update existing RM buddy plz search
              them and update their detail individually. To assign/change their
              buddy blocks go to the map. Search buddy block by name of block.
              Click on it and add/update RM buddy.
            </p>
            {/* For submiting on hitting enter button hack*/}
            <Form onSubmit={submitButtonHandler}>
              <input type="file" name="file" onChange={onChangeHandler} />
            </Form>
          </Modal.Content>
        )}
        {!fileUploaded && (
          <Modal.Actions>
            <a href={"/"}>
              <Button color="red" inverted>
                Cancel
              </Button>
            </a>
            <Button onClick={submitButtonHandler} color="green" inverted>
              Upload
            </Button>
          </Modal.Actions>
        )}
        {fileUploaded && <Modal.Content>{fileUploaded.msg}</Modal.Content>}
        {fileUploaded && (
          <Modal.Actions>
            <a href="/">
              <Button color="green" inverted>
                Done
              </Button>
            </a>
          </Modal.Actions>
        )}
      </Modal>
    </div>
  );
}

export default MultiCreateRmBuddies;
